import React, { useContext, useEffect, useRef, useState } from "react";

import {
  CardContent,
  LinearProgress,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";

import { getLoneworkerOrgSettings } from "../../../../api/endpoints/lone-worker";
import { callOptionsHeaders } from "../../../../api/helpers";
import { SnackbarContext } from "../../../../context/snackbar-context";
import TabPanel from "../../../shared/tab-panel";
import SettingsMonitoring from "./monitoring/monitoring";
import SatelliteDevices from "./satellite-devices/satellite-devices";
import { SettingsContext } from "./settings-context";

interface Props {
  roleId: string;
  regionCode: string;
}

const Settings = (props: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tabValue, setTabValue] = useState(0);
  const { showError } = useContext(SnackbarContext);

  const handleTabChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number,
  ) => {
    setTabValue(newValue);
  };
  const {
    setRoleId,
    setMonitoringSeatsTotal,
    setMonitoringSeatsUsed,
    setMonitoringCompany,
    setRegionCode,
  } = useContext(SettingsContext);

  setRegionCode(props.regionCode);
  setRoleId(props.roleId);

  const getLoneWorkerSettings = useRef(() => {
    setIsLoading(true);
    getLoneworkerOrgSettings(
      props.roleId,
      callOptionsHeaders(props.regionCode, props.roleId),
    )
      .then((res) => {
        setMonitoringCompany(res.monitoringCompany);
        setMonitoringSeatsUsed(res.monitoringSeatsUsed);
        setMonitoringSeatsTotal(res.monitoringSeatsTotal);
        setIsLoading(false);
      })
      .catch(showError);
  });

  useEffect(() => {
    getLoneWorkerSettings.current();
  }, []);

  return (
    <>
      {isLoading ? (
        <LinearProgress data-testid="settings-is-loading-progress" />
      ) : (
        <Stack direction="column">
          <CardContent>
            <Typography variant="h6">Lone Worker Settings</Typography>
          </CardContent>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
          >
            <Tab label="24/7 Monitoring" data-testid="tab-option" />
            <Tab label="Satellite Devices" data-testid="tab-option" />
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            <SettingsMonitoring />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <SatelliteDevices />
          </TabPanel>
        </Stack>
      )}
    </>
  );
};

export default Settings;
